import { Component, OnInit, Inject } from '@angular/core';
import { ReservationService } from 'src/app/services/reservation.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MedicalAppointmentWaitTrace } from 'src/app/model/medical-appointment/medical-appointment-wait-trace';
import { MedicalAppointmentWaitState } from 'src/app/model/medical-appointment/medical-appointment-wait-state';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-medical-appointment-wait-trace-dialog',
  templateUrl: './medical-appointment-wait-trace-dialog.component.html',
  styleUrls: ['./medical-appointment-wait-trace-dialog.component.css']
})
export class MedicalAppointmentWaitTraceDialogComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  loadingAction: boolean;
  medicalAppointmentWaitTraces: MedicalAppointmentWaitTrace[];
  medicalAppointmentWaitStates: MedicalAppointmentWaitState[];

  constructor(private reservationService: ReservationService,
     private formBuilder: FormBuilder,
     private filterService: FilterService,
     private notificationToastService: NotificationToastService,
     public dialogRef: MatDialogRef<MedicalAppointmentWaitTraceDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any) {
    this.form = this.formBuilder.group({
      MedicalAppointmentWaitState: ['', Validators.required],
      Observation: ['']
    });
  } 

  get f() { return this.form.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async ngOnInit() { 
    
      this.loading = true;
      this.filterService.getMedicalAppointmentWaitStates().then((data) => {
        this.medicalAppointmentWaitStates = data;
      }) 

      this.reservationService.getMedicalAppointmentWaitTrace(this.data).then((data) => {
        this.medicalAppointmentWaitTraces = data;
        this.loading = false; 
      }).catch((err) => {   this.notificationToastService.error(JSON.stringify(err.error), 'Turno espera seguimiento'); }) 
  }

  async save() {
    try {
      if ( this.form.valid ) {
        this.loadingAction = true;
        await this.reservationService.medicalAppointmentWaitStateUpdate(this.data,
          this.form.controls.MedicalAppointmentWaitState.value.Id ,  this.form.controls.Observation.value);
          this.dialogRef.close(true);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Turno espera seguimiento');
    } finally {
      this.loadingAction = false;
    }
  }
}
